/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Footer_Company_CareersInputs */

const de_commons_footer_company_careers = /** @type {(inputs: Commons_Footer_Company_CareersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karriere`)
};

/** @type {(inputs: Commons_Footer_Company_CareersInputs) => LocalizedString} */
const en_commons_footer_company_careers = de_commons_footer_company_careers;

/**

* @param {Commons_Footer_Company_CareersInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_footer_company_careers = /** @type {((inputs?: Commons_Footer_Company_CareersInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Footer_Company_CareersInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_footer_company_careers(inputs)
	return en_commons_footer_company_careers(inputs)
});